import {
  ConeGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Nami mesh — tide staff + bubble cue. */
export function createNamiMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0x67e8f9 : 0xfcd34d;
  const bodyMat = new MeshStandardMaterial({ color: 0x0e7490, roughness: 0.5 });
  const trimMat = new MeshStandardMaterial({ color: trim, roughness: 0.35 });
  const staffMat = new MeshStandardMaterial({ color: 0xa5f3fc, metalness: 0.45, roughness: 0.4 });

  const body = new Mesh(new ConeGeometry(0.6, 2.1, 10), bodyMat);
  body.position.y = 1.25;
  group.add(body);

  const head = new Mesh(new SphereGeometry(0.4, 12, 12), trimMat);
  head.position.y = 2.55;
  group.add(head);

  const staff = new Mesh(new CylinderGeometry(0.05, 0.06, 2.3, 8), staffMat);
  staff.position.set(0.72, 1.7, 0.1);
  group.add(staff);

  const bubble = new Mesh(new SphereGeometry(0.24, 12, 12), trimMat);
  bubble.position.set(0.72, 3.0, 0.1);
  group.add(bubble);

  return group;
}
